import type { WorkflowFeatureKey } from "../types";

/**
 * Steps whose observable does not exist yet.
 *
 * A step that names one of these in `requires` is *hidden* — not shown as
 * incomplete — until the PR that builds the signal flips the flag here. That
 * keeps a permanently unachievable step out of a user's stepper while letting
 * the catalog be authored once, in full.
 *
 * - `negativeMessageAlerts` — ON. The nightly detector fires when a NEGATIVE
 *   key message starts (or keeps) surfacing. The W3 and W12 alert steps read
 *   the resolved recipient count for the property's NEGATIVE_MESSAGE audience
 *   (Settings, Notifications tab). Everyone in the org is the default, so
 *   those steps are complete out of the box and only go incomplete when the
 *   audience is narrowed to nobody or everyone has opted out.
 * - `messageMatches` — ON. `KeyMessageMatch` rows are persisted beside the
 *   mention metrics and the matched-answers drill-down under the message
 *   dashboard reads them, so the "trace the sources" steps have somewhere to
 *   send people. Evidence is forward-only: a property measured before this
 *   shipped has rates without answers behind them for those older days.
 *
 * Nothing is currently gated off. The map stays because the mechanism is what
 * lets the next unbuilt step be authored in place rather than held back.
 */
export const WORKFLOW_FEATURES: Record<WorkflowFeatureKey, boolean> = {
	negativeMessageAlerts: true,
	messageMatches: true,
};
